var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-agree",class:[
    _vm.disabled ? 'disabled' : ''
  ]},[_c('div',{staticClass:"agree-icon",class:[
      _vm.value ? 'checked' : ''
    ],on:{"click":function($event){return _vm.$_onChange($event)}}},[_c('md-icon',{attrs:{"name":_vm.iconName,"size":_vm.size}})],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bdd0222","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vxmobile/components/agree/index.vue
// module id = null
// module chunks = 